import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

const NotFound = () => {
  const error = useRouteError()
  return <div>{isRouteErrorResponse(error) ? '404 This page does not exist' : 'An unexpected error occured'}</div>
}
export default NotFound
